import { useMemo } from 'react';

export const useFilter = <T>(
  accessor: (item: T) => string[],
  xs: T[] | undefined,
  filter: string | undefined
) => {
  const loweredFilter = useMemo(() => filter?.toLowerCase(), [filter]);

  return useMemo(() => {
    if (!(loweredFilter && xs)) return xs;

    return xs.filter((item: T) => {
      const strings = accessor(item);
      return strings.some((s: string) => s.toLowerCase().includes(loweredFilter));
    });
  }, [loweredFilter, xs, accessor]);
};
